<template>
  <div
    ref="scalerContainer"
    :style="styles"
  >
    <slot v-bind="sizeData" />
  </div>
</template>

<script>
export default {
  name: 'Scaler',
  props: {
    scaled: Boolean,
    xAxis: {
      type: [Number, String],
      default: 1
    },
    yAxis: {
      type: [Number, String],
      default: 1
    },
    transitionTime: {
      type: String,
      default: '0.15s'
    }
  },
  data () {
    return {
      xScale: 1,
      yScale: 1,
      sizeData: {},
    }
  },
  computed: {
    transition () {
      return `transform ${this.transitionTime} ease-in-out, font-size ${this.transitionTime} ease-in-out`
    },
    styles () {
      let styles = {transition: this.transition}
      if (this.scaled) styles.transform = `scaleX(${this.xScale}) scaleY(${this.yScale})`
      return styles
    }
  },
  watch: {
    xAxis (newVal) {this.parseScale(newVal, 'xScale')},
    yAxis (newVal) {this.parseScale(newVal, 'yScale')},
    scaled () {this.updateSizeData()}
  },
  mounted () {
    this.parseScale(this.xAxis, 'xScale')
    this.parseScale(this.yAxis, 'yScale')
  },
  methods: {
    parseScale (value, destination) {
      let result = 1
      if (!isNaN(value?.toString())) result = value
      this[destination] = result
      this.updateSizeData()
    },
    updateSizeData () {
      const scaler = this.$refs.scalerContainer
      const [baseHeight, baseWidth] = [scaler.offsetHeight, scaler.offsetWidth]
      const {xScale, yScale} = this
      this.sizeData = {
        baseHeight,
        baseWidth,
        xScale,
        yScale,
        antiScaleX: 1 / parseFloat(xScale),
        antiScaleY: 1 / parseFloat(yScale),
        scaled: this.scaled,
        fontSize: `${16 * this.yScale}px`,
        transition: this.transition,
        height: baseHeight * this.yScale,
        width: baseWidth * this.xScale
      }
    }
  }
}
</script>
